import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const InterruptionWrapper = (props) => {
	const sectionClasses = {
		"discovery-section": true,
		"discovery-section--interruption": true,
		[props.className]: !!props.className,
	};

	return (
		<div className={classnames(sectionClasses)}>
			<div className="discovery-section-content">
				{props.children}
			</div>
		</div>
	);
};

InterruptionWrapper.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export default InterruptionWrapper;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/interruptions/InterruptionWrapper.jsx